/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ArcHospiDto } from '../models/arc-hospi-dto';
import { arcHospiPost } from '../fn/arc-hospi/arc-hospi-post';
import { ArcHospiPost$Params } from '../fn/arc-hospi/arc-hospi-post';
import { arcHospiPut } from '../fn/arc-hospi/arc-hospi-put';
import { ArcHospiPut$Params } from '../fn/arc-hospi/arc-hospi-put';

@Injectable({ providedIn: 'root' })
export class ArcHospiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `arcHospiPost()` */
  static readonly ArcHospiPostPath = '/v1/ArcHospi/Post';

  /**
   * Insert/Update arcHospi,   Permissions [LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the created/updated
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `arcHospiPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  arcHospiPost$Response(params?: ArcHospiPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ArcHospiDto>> {
    return arcHospiPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Insert/Update arcHospi,   Permissions [LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the created/updated
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `arcHospiPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  arcHospiPost(params?: ArcHospiPost$Params, context?: HttpContext): Observable<ArcHospiDto> {
    return this.arcHospiPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ArcHospiDto>): ArcHospiDto => r.body)
    );
  }

  /** Path part for operation `arcHospiPut()` */
  static readonly ArcHospiPutPath = '/v1/ArcHospi/Put';

  /**
   * Insert/Update arcHospi,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the created/updated
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `arcHospiPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  arcHospiPut$Response(params?: ArcHospiPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ArcHospiDto>> {
    return arcHospiPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Insert/Update arcHospi,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the created/updated
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `arcHospiPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  arcHospiPut(params?: ArcHospiPut$Params, context?: HttpContext): Observable<ArcHospiDto> {
    return this.arcHospiPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<ArcHospiDto>): ArcHospiDto => r.body)
    );
  }

}
